import axios from "axios";

// Resolve the API base URL.
// Rules:
//   1. When running in a browser on an Emergent-owned domain (preview or deployed),
//      always use a RELATIVE `/api` path so requests stay same-origin. This avoids
//      CORS + cookie issues that occur when the baked-in REACT_APP_BACKEND_URL
//      points to a different host from the current origin (very common after deploy).
//   2. Otherwise fall back to REACT_APP_BACKEND_URL (e.g. for local dev where the
//      frontend runs on :3000 and backend on :8001).
function resolveApiBase() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (typeof window !== "undefined") {
    // In production (preview, deployed Emergent host, OR a custom domain like
    // menumojo.in) the Emergent ingress routes /api/* to the FastAPI backend
    // on whichever host is serving the frontend. Using a relative /api path
    // keeps every request same-origin, which:
    //   • eliminates CORS preflights
    //   • guarantees the HttpOnly auth cookie is always sent back
    //   • means the app works even on custom domains without any config change
    //
    // The only exception is local development where the frontend runs on :3000
    // and the backend on :8001 — in that case the REACT_APP_BACKEND_URL env
    // var must point explicitly at the backend host:port.
    const host = window.location.host;
    const isLocalDev = /^(localhost|127\.0\.0\.1)(:\d+)?$/.test(host);
    if (!isLocalDev) return "/api";
  }
  return envUrl ? `${envUrl}/api` : "/api";
}

export const API = resolveApiBase();

// v2.0: auth is carried by an HttpOnly cookie set by the backend.
// We only add the X-Restaurant-Id header for multi-outlet routing.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const restaurantId = localStorage.getItem("menumojo_active_restaurant");
  if (restaurantId) config.headers["X-Restaurant-Id"] = restaurantId;
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}

export const CURRENCY_SYMBOLS = { USD: "$", INR: "₹", EUR: "€", GBP: "£" };
export const currencySymbol = (c) => CURRENCY_SYMBOLS[c] || c;
